import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "../../../box/src";
import { FontAwesomeIcon } from "../../../font-awesome-icon/src";
export const PillIcon = ({ iconName, iconType, }) => (_jsx(Box, { mr: "6px", style: { color: 'inherit' }, children: _jsx(FontAwesomeIcon, { height: "12px", iconName: iconName, iconType: iconType }) }));
//# sourceMappingURL=PillIcon.js.map